import { RoomId, roomId, StreamId, streamId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStreamActiveSetCmd {
  private static validation = JsonSchemaValidator.compile(
    RoomStreamActiveSetCmd.validationSchema()
  );

  constructor(readonly cmd: RoomStreamActiveSet) {
    JsonSchemaValidator.assert(RoomStreamActiveSetCmd.validation, cmd);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "streamId"],
      properties: {
        roomId,
        streamId
      }
    };
  }
}

interface RoomStreamActiveSet {
  roomId: RoomId;
  streamId: StreamId;
}
